// extracted by mini-css-extract-plugin
export var article = "style-module--article--bb205";
export var content = "style-module--content--1c48c";
export var inner = "style-module--inner--f76d1";
export var landingPage = "style-module--landingPage--b0cf1";
export var outer = "style-module--outer--f7010";
export var spacerDiv = "style-module--spacerDiv--611db";